import React, { useState, useEffect } from 'react';
import EditUserBillingDetails from './EditUserBillingDetails';
import { getUserBillingDetails, saveUserBillingDetails } from 'services/user';

const UserDetailsBilling = () => {
    const [visible, setVisible] = useState(false);
    const [billingData, setBillingData] = useState([]);

    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };

    const setEmptyString = (items) => {
        let newDetails = {};
        for (let item in items) {
            newDetails[item] = items[item] == null ? '' : items[item];
        }

        return newDetails;
    };

    useEffect(() => {
        getUserBillingDetails()
            .then((res) => {
                const billingDataString = setEmptyString(res.data.results[0]);
                // console.log(billingDataString);
                setBillingData(billingDataString);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    // console.log(`billingDataX`, billingData);

    return (
        <>
            <div className="billing-details-container">
                <div className="billing-details-box">
                    <div className="per-info-box">
                        <div className="per-info-title">
                            Personal Information
                        </div>
                        <div className="per-info-desc">
                            {billingData.salutation_display}{' '}
                            {billingData.first_name} {billingData.last_name}
                        </div>
                    </div>
                    <div className="invoice-info-container">
                        <div className="invoice-info-title">
                            Invoice Information
                        </div>

                        <div className="invoice-info-box">
                            <div className="invoice-info-row">
                                <div>
                                    <div className="title">Customer Type</div>
                                    <div className="description">
                                        {billingData.customer_type_display}
                                    </div>
                                </div>
                                <div></div>
                            </div>

                            <div className="invoice-info-row">
                                <div>
                                    <div className="title">Organization</div>
                                    <div className="description">
                                        {billingData.organization}
                                    </div>
                                </div>
                                <div></div>
                            </div>

                            <div className="invoice-info-row">
                                <div>
                                    <div className="title">Tax ID Number</div>
                                    <div className="description">
                                        {billingData.vat_tin_no}
                                    </div>
                                </div>
                                <div></div>
                            </div>

                            <div className="invoice-info-row">
                                <div>
                                    <div className="title">Country</div>
                                    <div className="description">
                                        {billingData.country_display}
                                    </div>
                                </div>
                                <div></div>
                            </div>

                            <div className="invoice-info-row">
                                <div>
                                    <div className="title">Street Address</div>
                                    <div className="description">
                                        <div>
                                            {billingData.street}{' '}
                                            {billingData.street_number}
                                        </div>
                                        <div>{billingData.city}</div>
                                        <div>{billingData.state}</div>
                                        <div>{billingData.zip_code}</div>
                                    </div>
                                </div>
                                <div></div>
                            </div>

                            <div className="invoice-info-row">
                                <div>
                                    <div className="title">Phone</div>
                                    <div className="description">
                                        {billingData.phone}
                                    </div>
                                </div>
                                <div></div>
                            </div>

                            <div className="invoice-info-row-100">
                                <div>
                                    <div className="title">Notes</div>
                                    <div className="description">
                                        {billingData.additional_information}
                                    </div>
                                </div>
                                <div></div>
                            </div>

                            <div className="invoice-info-row-edit">
                                <div>
                                    <div className="edit" onClick={showDrawer}>
                                        Edit Details
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {visible ? (
                <EditUserBillingDetails
                    visible={visible}
                    setVisible={setVisible}
                    showDrawer={showDrawer}
                    onClose={onClose}
                    setBillingData={setBillingData}
                    billingData={billingData}
                />
            ) : null}
        </>
    );
};

export default UserDetailsBilling;
